import { useState, useRef } from 'react';

export default function NewsletterSection() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      form.reset();
      return;
    }

    setStatus('loading');
    setErrorMessage('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d96agsn0d76aer3t5220', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed && parsed.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const serverMsg = (parsed as { meta?: { message?: string } } | null)?.meta?.message
          || (parsed as { message?: string } | null)?.message
          || (parsed as { meta?: { detail?: string } } | null)?.meta?.detail
          || responseText;
        if (typeof serverMsg === 'string' && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
          setStatus('error');
          setErrorMessage('提交失败，请稍后重试');
        } else {
          setStatus('error');
          setErrorMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
        }
      }
    } catch {
      setStatus('error');
      setErrorMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-3">
            订阅最新爆料
          </h2>
          <p className="text-sm text-foreground-600 mb-8 leading-relaxed">
            第一时间获取最新网红黑料和明星塌房资讯，吃瓜永不掉队
          </p>

          {status === 'success' ? (
            <div className="py-8 px-6 bg-accent-100 rounded-2xl">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/20 mx-auto mb-3">
                <i className="ri-check-line text-2xl text-accent-500"></i>
              </div>
              <p className="text-sm font-medium text-accent-800">订阅成功！感谢你的关注</p>
              <p className="text-xs text-accent-600 mt-1">最新爆料将第一时间发送到你的邮箱</p>
            </div>
          ) : (
            <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="">
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入你的邮箱地址"
                  className="flex-1 px-5 py-3 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  {status === 'loading' ? '提交中...' : '立即订阅'}
                </button>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              {status === 'error' && (
                <p className="mt-3 text-xs text-red-500">{errorMessage}</p>
              )}
            </form>
          )}

          <p className="mt-4 text-xs text-foreground-400">
            我们尊重你的隐私，绝不做垃圾邮件轰炸
          </p>
        </div>
      </div>
    </section>
  );
}